/**
 * Status på en lokasjon i et prosjekt (VIB-2940, plan § 3.7 og § 5.3b).
 * Badgene er status-badgene fra styleguiden, ikke KPI-paletten: dette er
 * fremdrift, ikke måloppnåelse.
 */
import type { ProjectLocationStatus } from "@/lib/db-types";

export const PROJECT_LOCATION_STATUSES: readonly ProjectLocationStatus[] = ["suggested", "scouted", "selected", "used", "rejected"];

export const PROJECT_LOCATION_STATUS_LABEL: Record<ProjectLocationStatus, string> = {
  suggested: "Forslag",
  scouted: "Befart",
  selected: "Valgt",
  used: "Brukt",
  rejected: "Forkastet",
};

/** Klassene fra STATUS_BADGES i StyleGuidePage: hvit, gul, Reveblå, grønn og rød. */
export const PROJECT_LOCATION_STATUS_CLASS: Record<ProjectLocationStatus, string> = {
  suggested: "bg-white text-[var(--sr-revemoerk)] border-[var(--sr-revemoerk)]",
  scouted: "bg-[#FEF3C7] text-[#78350F] border-[var(--sr-revemoerk)]",
  selected: "bg-[var(--sr-reveblaa)] text-white border-[var(--sr-reveblaa)]",
  used: "bg-[#D9F5E8] text-[#035C39] border-[var(--sr-revemoerk)]",
  rejected: "bg-[#FFE1DB] text-[#7F1D1D] border-[var(--sr-revemoerk)]",
};

/** Verktøyets historikktekst som linjer, uten punkttegn. */
export function legacyLines(text: string | null | undefined): string[] {
  return (text ?? "")
    .split(/\n+/)
    .map((l) => l.replace(/^•\s*/, "").trim())
    .filter(Boolean);
}

/** Linjene som ikke er erstattet av en kobling (koblingens legacy_text). */
export function unlinkedLegacyLines(text: string | null | undefined, linked: Array<string | null>): string[] {
  const done = new Set(linked.filter((l): l is string => !!l).map((l) => l.trim()));
  return legacyLines(text).filter((l) => !done.has(l));
}

/** «Valgt» i prosjektfanen sorteres øverst, så Befart, Forslag, Brukt og Forkastet. */
const ORDER: Record<ProjectLocationStatus, number> = { selected: 0, scouted: 1, suggested: 2, used: 3, rejected: 4 };

export function compareProjectLocationStatus(a: ProjectLocationStatus, b: ProjectLocationStatus): number {
  return ORDER[a] - ORDER[b];
}
